const LanguageCurrency = () => {
  return (
    <>
      <div className=" display-max">
        <div className="cursor-pointer dropdown">
          <div
            className=" d-flex justify-content-center align-items-center cursor-pointer"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div>
              <i className="ri-global-line fs-4 text-black me-1"></i>
            </div>
            <div className=" mt-n1">
              <b className=" text-nowrap text-black fw-normal text-sm">
                {" "}
                English - INR <i className="ri-arrow-drop-down-line ms-n1"></i>
              </b>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-two border p-2 px-3 min-w-25 border-radius-lg mt-3 ms-n8"
            aria-labelledby="dropdownMenuButton"
          >
            <div className=" p-2">
              <b className=" text-black fw-bolder fs-6">
                Set language and currency
              </b>
              <div className=" mt-2 lh-sm">
                <b className=" text-black fw-normal text-xs text-wrap">
                  Select your preferred language and currency. You can update
                  the settings at any time.
                </b>
              </div>
              <div>
                <div className=" mt-3 mb-3 dropdown">
                  <label className=" form-label text-black">Language</label>
                  <div
                    className=" input-group input-group-outline"
                    id="dropdownCountry"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="English"
                    />
                    <span className=" input-group-text">
                      <b className=" text-black-50 fw-normal mt-n1"> &#124; </b>
                      <i className="fi fi-rr-angle-small-down ms-2 fs-6 mt-1 opacity-7"></i>
                    </span>
                  </div>
                  <div
                    className="dropdown-menu dropdown-menu-four dropdown-lg p-2 px-3"
                    aria-labelledby="dropdownCountry"
                  >
                    <div className=" mb-2">
                      <b className=" text-black-50 text-xs fw-bolder">
                        Suggested
                      </b>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            English
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Hindi
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Telugu
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Tamil
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Kannada
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Malayalam
                          </b>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" mt-3 mb-3 dropdown">
                  <label className=" form-label text-black">Currency</label>
                  <div
                    className=" input-group input-group-outline"
                    id="dropdownCountry"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="INR - Indian Rupee"
                    />
                    <span className=" input-group-text">
                      <b className=" text-black-50 fw-normal mt-n1"> &#124; </b>
                      <i className="fi fi-rr-angle-small-down ms-2 fs-6 mt-1 opacity-7"></i>
                    </span>
                  </div>
                  <div
                    className="dropdown-menu dropdown-menu-four dropdown-lg p-2 px-3"
                    aria-labelledby="dropdownCountry"
                  >
                    <div className=" mb-2">
                      <b className=" text-black-50 text-xs fw-bolder">
                        Suggested
                      </b>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            USD - US Dollar
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            PHP - Philippine Peso
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            DOP - Dominican Peso
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            GEL - Georgian Lari
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            GTQ - Guatemalan Quetzal
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            CLP - Chilean Peso
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            PEN - Peruvian Sol
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            COP - Colombian Peso
                          </b>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 mb-4">
                  <button className=" btn btn-md rounded-pill w-100 btn-dark">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className="cursor-pointer dropdown">
          <div
            className=" d-flex justify-content-center align-items-center cursor-pointer"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div>
              <i className="ri-global-line fs-4 text-black me-1"></i>
            </div>
            <div className=" mt-n0">
              <b className=" text-nowrap text-black fw-normal text-sm"> Eng</b>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-two border p-2 px-3 min-w-20 border-radius-lg mt-3"
            aria-labelledby="dropdownMenuButton"
          >
            <div className=" p-2">
              <b className=" text-black fw-bolder fs-6">
                Set language and currency
              </b>
              <div className=" mt-2 lh-sm">
                <b className=" text-black fw-normal text-xs text-wrap">
                  Select your preferred language and currency. You can update
                  the settings at any time.
                </b>
              </div>
              <div>
                <div className=" mt-3 mb-3 dropdown">
                  <label className=" form-label text-black">Language</label>
                  <div
                    className=" input-group input-group-outline"
                    id="dropdownCountry"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="English"
                    />
                    <span className=" input-group-text">
                      <b className=" text-black-50 fw-normal mt-n1"> &#124; </b>
                      <i className="fi fi-rr-angle-small-down ms-2 fs-6 mt-1 opacity-7"></i>
                    </span>
                  </div>
                  <div
                    className="dropdown-menu dropdown-menu-four dropdown-lg p-2 px-3"
                    aria-labelledby="dropdownCountry"
                  >
                    <div className=" mb-2">
                      <b className=" text-black-50 text-xs fw-bolder">
                        Suggested
                      </b>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            English
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Hindi
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Telugu
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Tamil
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Kannada
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            Malayalam
                          </b>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" mt-3 mb-3 dropdown">
                  <label className=" form-label text-black">Currency</label>
                  <div
                    className=" input-group input-group-outline"
                    id="dropdownCountry"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="INR - Indian Rupee"
                    />
                    <span className=" input-group-text">
                      <b className=" text-black-50 fw-normal mt-n1"> &#124; </b>
                      <i className="fi fi-rr-angle-small-down ms-2 fs-6 mt-1 opacity-7"></i>
                    </span>
                  </div>
                  <div
                    className="dropdown-menu dropdown-menu-four dropdown-lg p-2 px-3"
                    aria-labelledby="dropdownCountry"
                  >
                    <div className=" mb-2">
                      <b className=" text-black-50 text-xs fw-bolder">
                        Suggested
                      </b>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            USD - US Dollar
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            PHP - Philippine Peso
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            DOP - Dominican Peso
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            GEL - Georgian Lari
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            GTQ - Guatemalan Quetzal
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            CLP - Chilean Peso
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            PEN - Peruvian Sol
                          </b>
                        </a>
                      </div>
                    </div>
                    <div className="mt-0 dropdown-item border-radius-md mb-1 p-1">
                      <div>
                        <a href=".">
                          <b className="text-md fw-normal text-black ms-2">
                            COP - Colombian Peso
                          </b>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 mb-4">
                  <button className=" btn btn-md rounded-pill w-100 btn-dark">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LanguageCurrency;
